import { getYearMonth } from "../calendar";
import fetchJson from '../lib/react-admin-loopback/fetch';

export async function reqTaxInvoice(yearmonth){

  const apiUrl = process.env.REACT_APP_FCS_API_URL;
  const url = `${apiUrl}/customer-taxinvoice?yearMonth=${getYearMonth(yearmonth)}`;

  const { json } = await fetchJson(url);
  return { 
   data : json
};
}
